<div class="ls" [class.ls-aberto]="aberto" [class.ls-desabilitado]="desabilitado">
  <button #gatilho type="button" class="ls-gatilho" [disabled]="desabilitado" (click)="alternar()" (keydown)="teclaGatilho($event)"
          aria-haspopup="listbox" [attr.aria-expanded]="aberto" [attr.aria-label]="rotuloAcessivel || null">
    <span class="ls-icone"><ng-content></ng-content></span>
    <span class="ls-texto" [class.ls-placeholder]="!selecionado">{{ selecionado?.rotulo || placeholder }}</span>
    <span class="ls-seta" aria-hidden="true"></span>
  </button>

  <div *ngIf="aberto" class="ls-painel">
    <div *ngIf="comBusca" class="ls-busca">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
      </svg>
      <input #campoBusca [(ngModel)]="termo" (ngModelChange)="onBusca()" (keydown)="teclaLista($event)"
             placeholder="Buscar..." aria-label="Buscar na lista" autocomplete="off" />
    </div>
    <div class="ls-itens" role="listbox">
      <ng-container *ngFor="let item of filtrados; let n = index; trackBy: porValor">
      <p *ngIf="fixada && n === 0" class="ls-secao">Última usada</p>
      <p *ngIf="fixada && n === 1" class="ls-secao">Todas</p>
      <button type="button" role="option" class="ls-item"
              [class.ls-ativo]="n === indice" [attr.aria-selected]="item.valor === valor"
              (mouseenter)="indice = n" (click)="escolherItem(item)" (keydown)="teclaLista($event)">
        <span class="ls-item-texto">
          {{ item.rotulo }}
          <small *ngIf="item.detalhe">{{ item.detalhe }}</small>
        </span>
        <svg *ngIf="item.valor === valor" class="ls-check" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
        </svg>
      </button>
      </ng-container>
      <p *ngIf="!filtrados.length" class="ls-vazio">Nada encontrado.</p>
    </div>
  </div>
</div>
